"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKBottomDrawerContainer = exports.GKBottomDrawerContext = void 0;
var React = __importStar(require("react"));
// import { GKBottomDrawer } from '../';
var common_1 = require("../../../common");
var hooks_1 = require("../../../common/hooks");
require("./GKBottomDrawerContainer.css");
// ----- CONSTANTS ------
var DEFAULT_SNAP_POINTS = { low: 75, high: 0.75 };
// ----- CONTEXT -----
exports.GKBottomDrawerContext = React.createContext({
    height: 0,
    fullscreen: false,
    snapClass: "",
    snapPoint: "low",
    toggle: function () {
        return;
    },
});
// ----- COMPONENT -----
/**
 * Component which acts as a container for GKBottomDrawer. Can contain any number of children,
 * but should only contain a single GKBottomDrawer child. Children which are not a drawer
 * will be overlaid by the drawer when it is open.
 */
var GKBottomDrawerContainer = function (props) {
    var children = props.children, initialSnapPoint = props.initialSnapPoint, fullscreen = props.fullscreen, onSnapPointChange = props.onSnapPointChange, snapPoints = props.snapPoints, otherProps = __rest(props, ["children", "initialSnapPoint", "fullscreen", "onSnapPointChange", "snapPoints"]);
    var containerRef = React.useRef(null);
    // ----- STATES -----
    var _a = React.useState(DEFAULT_SNAP_POINTS), rawSnapPoints = _a[0], setRawSnapPoints = _a[1]; // Unmodified. Can contain percentages.
    var _b = React.useState(props.initialSnapPoint || "low"), currentSnapPoint = _b[0], setCurrentSnapPoint = _b[1]; // Single string value of low || high
    var _c = React.useState(), bottomDrawer = _c[0], setBottomDrawer = _c[1];
    var _d = React.useState(), filteredChildren = _d[0], setFilteredChildren = _d[1];
    var _e = React.useState(false), shouldUpdatePixelSnapPoints = _e[0], setShouldUpdatePixelSnapPoints = _e[1];
    // Converts the props snap points to pixel versions based on the container height.
    var getPixelSnapPoints = function () {
        var newPixelSnapPoints = __assign({}, rawSnapPoints);
        if (containerRef && containerRef.current) {
            for (var point in newPixelSnapPoints) {
                if (newPixelSnapPoints[point] <= 1) {
                    newPixelSnapPoints[point] =
                        containerRef.current.clientHeight * newPixelSnapPoints[point];
                }
            }
        }
        return newPixelSnapPoints;
    };
    var _f = React.useState(getPixelSnapPoints()), pixelSnapPoints = _f[0], setPixelSnapPoints = _f[1]; // Modified. Only contains pixels.
    // Gets/sets pixel snap points
    // (called when useResponsive returns new snap points, the consumer provides new snap points, or the user resizes)
    var savePixelSnapPoints = function () {
        return setPixelSnapPoints(getPixelSnapPoints());
    };
    // On resize, set a boolean to update next run (ensures useResponsive has a chance to set the proper snap points first)
    var handleResize = function () { return setShouldUpdatePixelSnapPoints(true); };
    // ----- RESPONSIVE/RESIZE SNAP POINT HANDLING -----
    (0, hooks_1.useResponsive)(snapPoints || DEFAULT_SNAP_POINTS, setRawSnapPoints);
    // If a resize event indicated we should update our pixel snap points, do so.
    if (shouldUpdatePixelSnapPoints) {
        savePixelSnapPoints();
        setShouldUpdatePixelSnapPoints(false);
    }
    // ----- INTERNAL FUNCTIONS -----
    // Loop through the children and save out the drawer and 'everything else' separately.
    var filterChildren = function () {
        var kids = [];
        var drawer;
        React.Children.forEach(props.children, function (child) {
            // PROBABLY this is a bad idea.
            if (child && child.type.toString().includes("gk-bottom-drawer")) {
                drawer = child;
            }
            else {
                kids.push(child);
            }
        });
        setFilteredChildren(kids);
        setBottomDrawer(drawer);
    };
    // Toggle the drawer's snap point and calls the onToggle callback if it exists.
    // If the drawer is fullscreen, we always toggle to "high"
    var toggleDrawer = function () {
        var newSnapPoint = fullscreen || currentSnapPoint === "low" ? "high" : "low";
        if (onSnapPointChange) {
            onSnapPointChange(newSnapPoint);
        }
        setCurrentSnapPoint(newSnapPoint);
    };
    // ----- EFFECTS -----
    // Filter the children whenever children change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    React.useEffect(function () { return filterChildren(); }, [children]);
    // Set the initial snap point as the current snap point when it's passed to us.
    React.useEffect(function () { return setCurrentSnapPoint(initialSnapPoint || "low"); }, [
        initialSnapPoint,
    ]);
    // Compute and save the snap points when the raw snap points change (via props or useResponsive).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    React.useEffect(function () { return savePixelSnapPoints(); }, [rawSnapPoints]);
    // Re-compute and save the snap points when the window resizes.
    React.useEffect(function () {
        window.addEventListener("resize", handleResize);
        return function () { return window.removeEventListener("resize", handleResize); };
    }, []);
    // Render!
    return (React.createElement("div", __assign({}, (0, common_1.mapDefaultProps)(otherProps, {
        _gkComponentName: "gk-bottom-drawer-container",
    }), { ref: containerRef }),
        React.createElement("div", { className: "gk-bottom-drawer-container-content", style: bottomDrawer !== undefined
                ? { paddingBottom: pixelSnapPoints.low }
                : {} }, filteredChildren),
        React.createElement(exports.GKBottomDrawerContext.Provider, { value: {
                height: pixelSnapPoints[currentSnapPoint],
                fullscreen: fullscreen !== null && fullscreen !== void 0 ? fullscreen : false,
                snapClass: "gk-snap-point-" + currentSnapPoint,
                snapPoint: currentSnapPoint,
                toggle: toggleDrawer,
            } }, bottomDrawer)));
};
exports.GKBottomDrawerContainer = GKBottomDrawerContainer;
